import { render, staticRenderFns } from "./Patent-search.vue?vue&type=template&id=980d52ca&scoped=true&"
import script from "./Patent-search.vue?vue&type=script&lang=js&"
export * from "./Patent-search.vue?vue&type=script&lang=js&"
import style0 from "./Patent-search.vue?vue&type=style&index=0&id=980d52ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980d52ca",
  null
  
)

export default component.exports